// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"653":"amzn","792":"main"}[chunkId] + "." + {"653":"a1e5ba6c","792":"849a3a48"}[chunkId] + ".css";
};